// =============================================================================
// ranks.js — a person's clinical rank and on-call grade (Oct 2026)
// =============================================================================
// Both are numbers set on the person (src/logic/ranks.py): rank 0 (most
// senior) .. 4 ("Others"); on-call grade 0 consultant, 1 senior resident,
// 2 junior, or none. A title is display text and decides nothing.
// =============================================================================

const isInt = (v) => Number.isInteger(v);

/** The person's clinical rank, 4 when none is set. */
export const rankOf = (emp) => {
  const r = emp?.rankOverride ?? emp?.rank_override ?? emp?.rank;
  return isInt(r) ? r : 4;
};

/** The person's on-call grade, or null (in no on-call pool). */
export const gradeOf = (emp) => {
  const g = emp?.oncallRank ?? emp?.oncall_rank;
  return [0, 1, 2].includes(g) ? g : null;
};

/** "0 · Consultant" from the department's own names, or the bare number. */
export const numberLabel = (n, labels = {}) => {
  const name = String(labels?.[String(n)] || '').trim();
  return name ? `${n} · ${name}` : `${n}`;
};
